/* -------------------------------------------------------------------------- */
/*                             Video Navigation                                */
/* -------------------------------------------------------------------------- */

import video from 'views/screens/Video/sidebarLayout';

export default [
  {
    header: 'sidebar.video',
    iconName: 'Video',
    children: [...video] //Only to check permission in children inside
  },
  ...video
];
